// extracted by mini-css-extract-plugin
export default {"title":"delete_title__Tm-jH","buttonPart":"delete_buttonPart__4AuGM","buttonCancel":"delete_buttonCancel__Os4VX","buttonDelete":"delete_buttonDelete__wjFca"};